import type { Invoices as Invoice_Provider } from 'src/api/invoiceProvider/InvoiceProvider.class';
import { Invoices as Invoices_Config } from './config';
import { Invoices as Invoices_Types } from './types';

export namespace Invoices {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  export import Config = Invoices_Config.Config;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  export import Types = Invoices_Types.Types;
  export type InvoiceProvider = Invoice_Provider.InvoiceProvider;
}
